// =============================================================================
// CANONICAL PRICING & TIME LIMITS
// Single source of truth - all UI must pull from here
// =============================================================================

// Daily lounge time limits (in seconds) - LOCKED SPEC
export const VIDEO_LIMITS = {
  freeDailySeconds: 20 * 60,           // Free: 20 minutes
  innerCircleDailySeconds: 40 * 60,    // Inner Circle: 40 minutes
  eliteDailySeconds: 60 * 60,          // Elite: 60 minutes (1 hour)
  elitePlusDailySeconds: 120 * 60,     // Elite+: 120 minutes (2 hours)
};

// Pricing in USD - MUST match Stripe prices exactly
export const PRICING = {
  // Subscriptions
  innerCircleMonthly: 14.99,   // Inner Circle
  eliteMonthly: 19.99,         // Elite
  elitePlusMonthly: 39.99,     // Elite+
  
  // Boosts (one-time purchases)
  boost1Hour: 3.99,            // 60 minutes (must match Stripe "1 Hr Lounge Boost")
  boost4Hours: 10.00,          // 240 minutes (matches Stripe)
};

// Boost product details
export const BOOSTS = {
  boost_1h: { minutes: 60, price: 3.99 },
  boost_4h: { minutes: 240, price: 10.00 },
};

// Calculate per-hour cost for display
export const getBoost4HourPerHourPrice = () => {
  return (PRICING.boost4Hours / 4).toFixed(2);
};

// Helper function to format prices
export const formatPrice = (amount) => `$${amount.toFixed(2)}`;

// Helper to format remaining time
export const formatRemainingTime = (seconds) => {
  if (seconds === null || seconds === Infinity) {
    return 'Max Time';
  }
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes} minutes`;
};

// Get time limit for a subscription tier
export const getTimeLimitForTier = (tier) => {
  switch (tier) {
    case 'elite':
      return VIDEO_LIMITS.eliteDailySeconds;
    case 'premium':
    case 'lounge_plus':
      return VIDEO_LIMITS.premiumDailySeconds;
    case 'free':
    default:
      return VIDEO_LIMITS.freeDailySeconds;
  }
};
